import React from "react";
import { Box } from "@mui/material";
import { closeSnackbar, enqueueSnackbar } from "notistack";
import Button from "../Button";

declare module "notistack" {
  interface VariantOverrides {
    uploading: true;
    success: true;
    failed: true;
    merging: true;
    loading: true;
  }
  interface OptionsObject {
    description?: string;
    onClick?: VoidFunction;
    onClose?: VoidFunction;
    showClose?: boolean;
  }
}

export const showUploadMessage = ({
  variant,
  message,
  description,
  persist = false,
  hideOnClick = false,
  primaryCtaActionText,
  primaryCtaActionFunction,
  secondaryCtaActionText,
  secondaryCtaActionFunction,
  showClose = false,
}: {
  variant: "uploading" | "success" | "failed";
  message: string;
  description: string;
  persist?: boolean;
  hideOnClick?: boolean;
  primaryCtaActionFunction?: VoidFunction;
  primaryCtaActionText?: string;
  secondaryCtaActionFunction?: VoidFunction;
  secondaryCtaActionText?: string;
  showClose?: boolean;
}) => {
  const key = enqueueSnackbar(
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: "5px",
      }}
    >
      <Box
        sx={{
          fontWeight: 700,
          fontSize: "16px",
          lineHeight: "18px",
          color: "#0F1526",
        }}
      >
        {message}
      </Box>
      <Box
        sx={{
          fontWeight: 400,
          fontSize: "14px",
          lineHeight: "16px",
          color: "#6F737D",
          maxWidth: "250px",
        }}
      >
        {description}
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "5px",
          alignItems: "center",
        }}
      >
        {secondaryCtaActionText && secondaryCtaActionFunction && (
          <Button
            onClick={secondaryCtaActionFunction}
            variant="text"
            size="small"
          >
            {secondaryCtaActionText}
          </Button>
        )}
        {primaryCtaActionText && primaryCtaActionFunction && (
          <Button
            onClick={primaryCtaActionFunction}
            variant="contained"
            size="small"
          >
            {primaryCtaActionText}
          </Button>
        )}
      </Box>
    </Box>,
    {
      variant,
      persist,
      onClick: () => {
        hideOnClick && closeSnackbar(key);
      },
      description,
      showClose,
    }
  );
};

export const showMergeMessage = ({
  variant,
  message,
  description,
  persist = false,
  hideOnClick = false,
  primaryCtaActionText,
  primaryCtaActionFunction,
  secondaryCtaActionText,
  secondaryCtaActionFunction,
  showClose = false,
}: {
  variant: "merging" | "success" | "failed";
  message: string;
  description: string;
  persist?: boolean;
  hideOnClick?: boolean;
  primaryCtaActionFunction?: VoidFunction;
  primaryCtaActionText?: string;
  secondaryCtaActionFunction?: VoidFunction;
  secondaryCtaActionText?: string;
  showClose?: boolean;
}) => {
  const key = enqueueSnackbar(
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: "5px",
      }}
    >
      <Box
        sx={{
          fontWeight: 700,
          fontSize: "16px",
          lineHeight: "18px",
          color: "#0F1526",
        }}
      >
        {message}
      </Box>
      <Box
        sx={{
          fontWeight: 400,
          fontSize: "14px",
          lineHeight: "16px",
          color: "#6F737D",
          maxWidth: "250px",
        }}
      >
        {description}
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "5px",
          alignItems: "center",
        }}
      >
        {secondaryCtaActionText && secondaryCtaActionFunction && (
          <Button
            onClick={secondaryCtaActionFunction}
            variant="text"
            size="small"
          >
            {secondaryCtaActionText}
          </Button>
        )}
        {primaryCtaActionText && primaryCtaActionFunction && (
          <Button
            onClick={primaryCtaActionFunction}
            variant="contained"
            size="small"
          >
            {primaryCtaActionText}
          </Button>
        )}
      </Box>
    </Box>,
    {
      variant,
      persist,
      onClick: () => {
        hideOnClick && closeSnackbar(key);
      },
      description,
      showClose,
    }
  );
};
